var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4371_8328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3624 16.0568C11.2311 18.9443 8.85363 21.3181 5.96613 21.4531C2.71488 21.5993 0.0261278 19.0081 0.0261278 15.7868C0.0261278 15.7868 -0.776372 5.79683 6.51363 1.40558C6.80238 1.22933 7.14363 1.55183 6.97863 1.84808C5.86113 3.87683 3.49113 8.46683 3.77238 10.4506C4.37238 10.2331 5.02863 10.1131 5.70363 10.1131C8.92113 10.1131 11.5124 12.8018 11.3624 16.0568ZM23.9924 17.2418C23.8611 20.1293 21.4836 22.5031 18.5961 22.6381C15.3411 22.7881 12.6524 20.1968 12.6524 16.9756C12.6524 16.9756 11.8499 6.98558 19.1399 2.59433C19.4286 2.41808 19.7699 2.74058 19.6049 3.03683C18.4874 5.06558 16.1174 9.65558 16.3986 11.6393C16.9986 11.4218 17.6549 11.3018 18.3299 11.3018C21.5511 11.2981 24.1424 13.9868 23.9924 17.2418Z",
    fill: "#344157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4371_8328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.e2b5ba87.svg";
export { ForwardRef as ReactComponent };